import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'

import SettingsSidebar from './components/SettingsSidebar'
import { SettingsSidebarProvider } from '../../contexts/SettingsSidebarContext'

export default function SettingsPage() {
    return (
        <SettingsSidebarProvider>
            <Box sx={{ display: 'flex', height: '100%' }}>
                <SettingsSidebar />
                <Box sx={{ flex: 1, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
                    <Outlet />
                </Box>
            </Box>
        </SettingsSidebarProvider>
    )
}